import { Injectable, signal } from "@angular/core";


@Injectable({
  providedIn: 'root'
})
export class UserActivityService {
  private initialized = signal<boolean>(false);
  private readonly ACTIVITY_TIMEOUT = 300000; // 5 minutes
  private activityTimeoutId: any;
  public active = signal<boolean>(true);


  public initialize() {
    // Reset activity state and set up event listeners
    this.resetActivityTimeout();
    document.addEventListener('mousemove', this.handleActivity.bind(this));
    document.addEventListener('keydown', this.handleActivity.bind(this));
    document.addEventListener('click', this.handleActivity.bind(this));
    document.addEventListener('touchstart', this.handleActivity.bind(this));
    document.addEventListener('touchmove', this.handleActivity.bind(this));
    document.addEventListener('scroll', this.handleActivity.bind(this));

    this.initialized.set(true);
  }

  private handleActivity() {
    this.active.set(true);
    this.resetActivityTimeout();
  }

  private resetActivityTimeout() {
    if (this.activityTimeoutId) {
      clearTimeout(this.activityTimeoutId);
    }
    this.activityTimeoutId = setTimeout(() => {
      this.active.set(false);
      this.resetActivityTimeout();
    }, this.ACTIVITY_TIMEOUT);
  }
  
}